import { createContext, useContext } from 'react'

export const TranslationsContext = createContext<Record<string, string>>({})

export const useTranslations = () => useContext(TranslationsContext)

export const Translate: React.FC<{ id: string }> = ({ id }) => {
  const translations = useContext(TranslationsContext)

  return [Reflect.get(translations, id), id].find((x) => x != null)
}
